export default __webpack_public_path__ + "static/media/complementary--advisory-exit-or-ramp-speed--g1.d5aa6bd3.png";